<template>

<div :class="[ 'single', { 'is-hidden': singleIsHidden }]">

    <single-header :project="project">
        <p>Be it surfing the web in your favorite browser, buying something on Amazon
        or simply using your phone to play some games while on the train &mdash;
        data is being collected. This site explains what is happening and how one
        can prevent it.</p>

    </single-header>

    <!-- SECTION -->

    <single-section info :color="project.color" header="2nd Place in Digital Media Contest">

        <p>This project reached 2nd place in a digital media contest organized by the
        parliament of Baden-Württemberg, South Germany in 2017 for educational
        advertisting about data collection in our everyday lifes.</p>

    </single-section>

    <!-- SECTION -->

    <single-section>

        <img src="assets/projects/digital-data-collection/site.jpg" alt="Screenshot the website">

    </single-section>

    <single-section header="Page Transition">

        <p>The routing system which allows for a smooth page transition
        was designed from scratch since it is a rather simple setup
        with only five pages. To know which page to show, the scripts crawles the given URL
        and runs it through a switch. The new data is loaded via the Fetch API.</p>

        <video src="assets/projects/digital-data-collection/transition.mp4" autoplay loop></video>

    </single-section>


</div>

</template>

<script>
import { singleHandler } from '@/modules/mixins'

export default {
    data() {
        return {
            project: {
                title:'Digital Data Collection',
                subtitle: 'What\'s being saved? How can I secure myself?',
                background: 'url(assets/projects/digital-data-collection/project-header.jpg)',
                color:'#4e403f',
                logoSuffix: 'svg',
                role:'Informational',
                features:'Single Page App',
                url: 'https://datensammlung.artofmyself.com'
            }
        }
    },

    mixins: [singleHandler]
}
</script>



// WEBPACK FOOTER //
// digital-data-collection.vue?7f417590